import { memo } from 'react';

interface MobileCardSkeletonProps {
  count?: number;
  showFooter?: boolean;
  /** Overrides the id-value bar width (e.g. '8rem' for short names). */
  idValueWidth?: string;
}

const SkeletonCard = memo(function SkeletonCard({
  showFooter,
  idValueWidth,
}: {
  showFooter: boolean;
  idValueWidth?: string;
}) {
  return (
    <div className="mobile-skeleton-card" style={{ marginBottom: '1rem' }}>
      <div className="mobile-skeleton-header">
        <div>
          <div className="skeleton mobile-skeleton-id" />
          <div
            className="skeleton mobile-skeleton-id-value"
            style={idValueWidth ? { width: idValueWidth } : undefined}
          />
        </div>
        <div className="skeleton mobile-skeleton-badge" />
      </div>
      <div className="mobile-skeleton-stats">
        <div className="mobile-skeleton-stat">
          <div className="skeleton mobile-skeleton-stat-icon" />
          <div className="mobile-skeleton-stat-text">
            <div className="skeleton mobile-skeleton-stat-label" />
            <div className="skeleton mobile-skeleton-stat-value" />
          </div>
        </div>
        <div className="mobile-skeleton-stat">
          <div className="skeleton mobile-skeleton-stat-icon" />
          <div className="mobile-skeleton-stat-text">
            <div className="skeleton mobile-skeleton-stat-label" />
            <div className="skeleton mobile-skeleton-stat-value" />
          </div>
        </div>
      </div>
      {showFooter && (
        <div className="mobile-skeleton-footer">
          <div className="skeleton mobile-skeleton-address" />
          <div className="skeleton mobile-skeleton-qr" />
        </div>
      )}
    </div>
  );
});

export const MobileCardSkeleton = memo(function MobileCardSkeleton({
  count = 4,
  showFooter = true,
  idValueWidth,
}: MobileCardSkeletonProps) {
  return (
    <div className="mobile-stations-list">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} showFooter={showFooter} idValueWidth={idValueWidth} />
      ))}
    </div>
  );
});

export default MobileCardSkeleton;
